module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0iI2ZmZiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJGcmFtZSI+DQo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTguMDAwMSAyMC44NzEzTDI1LjE4OTUgMjguMDYwNkwyNy4zMTA4IDI1LjkzOTRMMTguMDAwMSAxNi42Mjg3TDguNjg5NDUgMjUuOTM5NEwxMC44MTA4IDI4LjA2MDZMMTguMDAwMSAyMC44NzEzWk05LjAwMDEyIDEwLjVIMjcuMDAwMVYxMy41SDkuMDAwMTJWMTAuNVoiIGZpbGw9IiNmZmYiLz4NCjwvZz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/go-top.svg
// module id = c5/K
// module chunks = 28